// Build-time configuration. Every variable is documented in apps/web/.env.example.
export const env = {
  /** Base URL of the Studio API. Empty = same origin (the dev server proxies /admin). */
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '',
  /** Fixtures mode: MSW serves the design's demo data through the real API client (D15). */
  fixtures: import.meta.env.VITE_FIXTURES === '1',
  /** Dev-only routes (/__ds) are on in dev and in fixtures builds, never in a normal build. */
  devRoutes: import.meta.env.DEV || import.meta.env.VITE_FIXTURES === '1',
} as const;
